import * as React from 'react';
import GenericFormModal from '@/components/form/GenericFormModal';
import { GenericFormGroup } from '@/components/form/GenericForm';
import { ITrk } from '@/stack-shared/interfaces/model/trk.interface';
import { IAtm } from '@/stack-shared/interfaces/model/atm.interface';
import { useMemo } from 'react';
interface RejectFormModalProps {
  visible: boolean
  onDismiss: () => void
  onSubmit: (values: any) => void
  initialValues: any
  title: string
  trks: ITrk[]
  atms: IAtm[]
  assetId?: number
  type?: string
}

function RejectFormModal({
 visible,
 onDismiss,
 onSubmit,
 initialValues,
 title, 
 trks,
 atms,
 assetId,
 type
}: RejectFormModalProps) {


  const fields = useMemo(() => {
    const baseFields = [
      { label: 'Reject Date', name: 'rejectDate', type: 'date', required: true, columns: 12  },
      { label: 'Reported Total Cash ($)', name: 'reportedTotalCash', type: 'number', required: true, columns: 12 },
      { label: 'Actual Cash Count ($)', name: 'actualCashCount', type: 'number', required: true, columns: 12 },
      { label: 'Difference ($)', name: 'difference', type: 'number', required: true, columns: 12 },
      { label: 'Comments', name: 'comments', type: 'text', required: false, columns: 12 },
    ]
    if (assetId) {
      return baseFields
    }

    const globalFields = [
      { label: 'Type', name: 'type', type: 'single-select', required: true, columns: 12, options: [{ label: 'Trk', value: 'trk' }, { label: 'Atm', value: 'atm' }] },
      { label: 'Trk', name: 'trkId', type: 'single-select', required: false, columns: 12, options: trks ? trks.filter(trk => trk.id !== undefined).map((trk) => ({ label: trk.assetId, value: trk.id as number })) : [], showConditions: [{ key: 'type', value: 'trk' }] },
      { label: 'Atm', name: 'atmId', type: 'single-select', required: false, columns: 12, options: atms ? atms.filter(atm => atm.id !== undefined).map((atm) => ({ label: atm.assetId, value: atm.id as number })) : [], showConditions: [{ key: 'type', value: 'atm' }] }
    ]

    if (type) {
      if (type === 'atm') {
        return [{ label: 'Atm', name: 'atmId', type: 'single-select', required: false, columns: 12, options: atms ? atms.filter(atm => atm.id !== undefined).map((atm) => ({ label: atm.assetId, value: atm.id as number })) : [] }, ...baseFields]
      }
      if (type === 'trk') {
        return [{ label: 'Trk', name: 'trkId', type: 'single-select', required: false, columns: 12, options: trks ? trks.filter(trk => trk.id !== undefined).map((trk) => ({ label: trk.assetId, value: trk.id as number })) : [] }, ...baseFields]
      }
    }

    return [...globalFields, ...baseFields]
  }, [assetId, atms, trks])

  const outageFields: GenericFormGroup[] = [{
    groupName: 'main',
    fields: fields
  }]

  return (
    <>
      <GenericFormModal
        visible={visible}
        onDismiss={onDismiss}
        onSubmit={onSubmit}
        initialValues={initialValues}
        fieldGroups={outageFields}
        title={title}
      />
    </>
  );
}

export default RejectFormModal;
